invHdApp.controller('ChangelogFormController', ['$scope', '$http', '$location', 
function($scope, $http, $location) {
    
    console.log('ChangelogFormController initialized');
    
    $http.defaults.headers.common['X-CSRF-TOKEN'] = CSRF_TOKEN;
    
    $scope.changelogs = [{
        category: '',
        description: '',
        changelog_id: ''
    }];

    $scope.addNewRow = function() {
        console.log('Adding new row');
        $scope.changelogs.push({
            category: '',
            description: '',
            changelog_id: ''
        });
    };

    $scope.saveChangelog = function(changelogs) {
        
        for(let log of changelogs) {
            if(!log.category || !log.description || !log.changelog_id) {
                Messenger().post({
                    message: 'Lütfen tüm alanları doldurunuz',
                    type: 'error'
                });
                return;
            }
        }

        $http.post('/api/changelog/save', {
            changelogs: changelogs,
            _token: CSRF_TOKEN
        })
            .then(function(response) {
                if (response.data.success) {
                    Messenger().post({
                        message: 'Changelog başarıyla kaydedildi',
                        type: 'success'
                    });

                    $scope.changelogs = [{
                        category: '',
                        description: '',
                        changelog_id: ''
                    }];
                }
            })
            .catch(function(error) {
                Messenger().post({
                    message: error.data.message || 'Bir hata oluştu',
                    type: 'error'
                });
            });
    };
}]); 